import {RoleBasedPermission} from '@hconnect/apiclient'
import {useUpmPlant} from '@hconnect/upm'
import {usePermission} from '@hproduce/permissions'

import {useUrlParam} from '@refra/modules/routing/hooks'

/**
 * Hook to check if the current user has permission to edit colors.
 * Only HProduce Production Manager OR HProduce Maintenance Manager can edit colors.
 */
export const useCanEditColors = (): boolean => {
  const plantId = useUrlParam('plantCode')
  const {country} = useUpmPlant({plantId})
  const plantContext = {plantId, countryId: country}

  const isProductionManager = usePermission({
    plantContext,
    permissionTypes: [RoleBasedPermission.HproduceRoleProductionManager]
  })

  const isMaintenanceManager = usePermission({
    plantContext,
    permissionTypes: [RoleBasedPermission.HproduceRoleMaintenanceManager]
  })

  return isProductionManager || isMaintenanceManager
}
